/* Filtrous - contextual (per-customer) PDP price (2026-08-04).

   The V3 app renders prices from a static asset (catalog-index.json) baked at
   theme build time, so every visitor sees list price - B2B customers included,
   even though Shopify computes their contract price in Liquid on every request
   and checkout charges it correctly.

   sections/filtrous-ctx-price.liquid emits that request-time Liquid price as
   window.FV3_CTX_PRICE. This script swaps it into the PDP price element and,
   when the two differ, keeps the static index value visible struck through as
   the list price - so the contract saving is legible rather than invisible.

   The struck value is read off the DOM because the app painted it from the
   static index, which IS list price. Liquid cannot supply it: for a
   company-location customer `variant.price` already resolves to the contract
   price, and compare_at_price means sale pricing, not B2B.

   That read happens ONCE per rendered node and is cached on the node itself
   (data-list-price). Re-deriving it from the DOM on re-entry would be wrong:
   after a swap the visible number is the contract price, so a second pass
   would strike the contract price and promote list - inverting the two.

   For logged-out visitors the two values are identical, no strikethrough is
   added, and the swap is a visual no-op.

   Scope: PDP only, and only when the rendered SKU matches the Liquid product -
   the app is a SPA-ish renderer, so we guard against it painting a different
   product than the one Liquid saw. Grid/search cards still show list price
   (known limitation, fix is a Liquid-rendered price endpoint).

   Revert: remove the Contextual price section from templates/product.json.
*/
(function () {
  if (window.__fctxInit) return;
  window.__fctxInit = true;

  var C = window.FV3_CTX_PRICE;
  if (!C || !C.sku || !C.price) return;

  var SHOW_WAS = C.showWas !== false;
  var MUT = '#5c6f7e'; /* --mut */

  /* text of the price node with the unit suffix and any prior strike removed */
  function bareText(el) {
    var probe = el.cloneNode(true);
    var ps = probe.querySelector('small');
    if (ps && ps.parentNode) ps.parentNode.removeChild(ps);
    var pw = probe.querySelector('.pdp-was');
    if (pw && pw.parentNode) pw.parentNode.removeChild(pw);
    return (probe.textContent || '').trim();
  }

  function apply() {
    var app = document.getElementById('fv3-app');
    if (!app) return;

    var part = app.querySelector('.fv3-buy .part');
    if (!part) return;
    if (part.textContent.trim().toUpperCase() !== String(C.sku).toUpperCase())
      return;

    var el = app.querySelector('.fv3-buy .pdp-price');
    if (!el) return;
    if (el.getAttribute('data-ctx-price') === C.price) return;

    /* capture list price once per node - see header note on re-entry */
    var listPrice = el.getAttribute('data-list-price');
    if (listPrice === null) {
      listPrice = bareText(el);
      el.setAttribute('data-list-price', listPrice);
    }

    /* the unit suffix ("/ pack") is reused verbatim */
    var small = el.querySelector('small');

    el.textContent = '';

    if (SHOW_WAS && listPrice && listPrice !== C.price) {
      var was = document.createElement('s');
      was.className = 'pdp-was';
      was.setAttribute(
        'style',
        'margin-right:8px;font-size:15px;font-weight:500;color:' + MUT + ';'
      );
      was.textContent = listPrice;
      el.appendChild(was);
    }

    el.appendChild(document.createTextNode(C.price + (small ? ' ' : '')));
    if (small) el.appendChild(small);
    el.setAttribute('data-ctx-price', C.price);
  }

  function boot() {
    apply();
    var mount = document.getElementById('fv3-app') || document.body;
    new MutationObserver(apply).observe(mount, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
